import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ABC_AUTH_API } from 'app/core/auth-abc/auth-abc-api.interceptor';
import { ApiResponseModel } from 'app/core/models/apiResponse.model';
import {
    ReferAndEarnDialogComponent,
    ReferAndEarnDialogData,
} from 'app/shared/components/atoms/refer-and-earn-dialog/refer-and-earn-dialog.component';
import { Observable } from 'rxjs';

const httpOptions = {
    context: new HttpContext().set(ABC_AUTH_API, true),
};

/** Referral code API response data. */
export interface ReferralCodeData {
    referralCode: string;
    shareableLink: string;
    content?: string;
    title?: string;
    description?: string;
    contentForFilmMaker?: string;
    contentForViewer?: string;
}

@Injectable({
    providedIn: 'root',
})
export class ReferAndEarnDialogService {
    private readonly dialog = inject(MatDialog);
    private readonly http = inject(HttpClient);

    /**
     * Get user's referral code from the API
     * @param countryCode - Country code for the referral (defaults to 'IN')
     * @returns Observable of referral code response
     */
    getUserReferralCode(
        countryCode: string = 'IN'
    ): Observable<ApiResponseModel<ReferralCodeData>> {
        const url = `/user/referralCode?countryCode=${countryCode}`;
        return this.http.get<ApiResponseModel<ReferralCodeData>>(
            url,
            httpOptions
        );
    }

    openReferAndEarnDialog(data?: Partial<ReferAndEarnDialogData>): void {
        const dialogData: ReferAndEarnDialogData = {
            referralCode: data?.referralCode || 'ONPKKN',
            title: data?.title,
            description: data?.description,
            contentForFilmMaker: data?.contentForFilmMaker,
            contentForViewer: data?.contentForViewer,
        };

        this.dialog.open(ReferAndEarnDialogComponent, {
            data: dialogData,
            width: '500px',
            maxWidth: '90vw',
            maxHeight: '90vh',
            disableClose: false,
            autoFocus: false,
            panelClass: 'refer-and-earn-dialog-container',
        });
    }
}
